import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4ee953a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "newCardModalRef",
  id: "kt_modal_new_card",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add a new Payment Method", -1))
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Card Number", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-70 end-0 me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/visa.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/mastercard.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/american-express.svg",
    alt: "",
    class: "h-25px"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2 my-3" }, "Card Expiry", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2 my-3" }, "Card CVC", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2 my-3" }, "Postal Code", -1))
const _hoisted_15 = { class: "text-center pt-15" }
const _hoisted_16 = ["data-kt-indicator"]
const _hoisted_17 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_18 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_StripeElements = _resolveComponent("StripeElements")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.stripeLoaded)
            ? (_openBlock(), _createBlock(_component_StripeElements, {
                key: 0,
                ref: "elms",
                "stripe-key": _ctx.stripeKey,
                "instance-options": _ctx.instanceOptions,
                "elements-options": _ctx.elementsOptions
              }, {
                default: _withCtx(({ elements }) => [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_StripeElement, {
                      class: "form-control form-control-solid",
                      ref: "cardNumber",
                      type: "cardNumber",
                      elements: elements,
                      options: _ctx.cardOptions
                    }, null, 8, ["elements", "options"]),
                    _hoisted_11
                  ]),
                  _hoisted_12,
                  _createVNode(_component_StripeElement, {
                    class: "form-control form-control-solid",
                    ref: "cardExpiry",
                    type: "cardExpiry",
                    elements: elements,
                    options: _ctx.cardOptions
                  }, null, 8, ["elements", "options"]),
                  _hoisted_13,
                  _createVNode(_component_StripeElement, {
                    class: "form-control form-control-solid",
                    ref: "cardCvc",
                    type: "cardCvc",
                    elements: elements,
                    options: _ctx.cardOptions
                  }, null, 8, ["elements", "options"]),
                  _hoisted_14,
                  _createVNode(_component_StripeElement, {
                    class: "form-control form-control-solid",
                    ref: "postalCode",
                    type: "postalCode",
                    elements: elements,
                    options: _ctx.cardOptions
                  }, null, 8, ["elements", "options"])
                ]),
                _: 1
              }, 8, ["stripe-key", "instance-options", "elements-options"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              href: "javacript:void(0)",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
              id: "kt_modal_new_card_cancel",
              class: "btn btn-white me-3"
            }, " Discard "),
            _createElementVNode("a", {
              href: "javacript:void(0)",
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addPaymentMethod && _ctx.addPaymentMethod(...args))),
              ref: "submitButtonRef",
              id: "kt_modal_new_card_submit",
              class: "btn btn-primary"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Submit "))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_21))
                : _createCommentVNode("", true)
            ], 8, _hoisted_16)
          ])
        ])
      ])
    ])
  ], 512))
}